import React from 'react';
import { useTranslation } from 'react-i18next';
import { sentimentLabel } from '../utils/insights';

export default function SentimentScore({ score = 0, breakdown }) {
  const { t } = useTranslation('tabs');
  const safe = Math.max(0, Math.min(100, Number(score) || 0));
  const breakdownText = breakdown
    ? `${breakdown.positive || 0} 💪  ·  ${breakdown.neutral || 0} →  ·  ${breakdown.alert || 0} ⚠️`
    : null;

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <span style={styles.label}>{t('insights.sentiment_global_label')}</span>
        <span style={styles.tag}>{sentimentLabel(safe, t)}</span>
      </div>
      <div style={styles.bigNumberRow}>
        <span style={styles.bigNumber}>{safe}</span>
        <span style={styles.suffix}>/100</span>
      </div>
      {breakdownText && <div style={styles.breakdown}>{breakdownText}</div>}
      <div style={styles.progressTrack}>
        <div style={{ ...styles.progressFill, width: `${safe}%` }} />
      </div>
      <div style={styles.hint}>{t('insights.sentiment_hint')}</div>
    </div>
  );
}

const styles = {
  card: {
    background: '#1A1A1A',
    color: '#FFFFFF',
    borderRadius: 20,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: '#9A9A9A',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  tag: {
    fontSize: 12,
    fontWeight: 700,
    color: '#FFFFFF',
    background: 'rgba(255,255,255,0.1)',
    padding: '4px 10px',
    borderRadius: 999,
  },
  bigNumberRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 6,
  },
  bigNumber: {
    fontSize: 56,
    fontWeight: 700,
    letterSpacing: '-0.03em',
    lineHeight: 1,
  },
  suffix: {
    fontSize: 18,
    color: '#9A9A9A',
    fontWeight: 600,
  },
  breakdown: {
    fontSize: 13,
    color: '#D7D7D2',
  },
  progressTrack: {
    marginTop: 6,
    height: 4,
    background: 'rgba(255,255,255,0.12)',
    borderRadius: 999,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    background: '#E8502A',
    borderRadius: 999,
    transition: 'width 600ms ease',
  },
  hint: {
    fontSize: 11,
    color: '#9A9A9A',
    marginTop: 4,
  },
};
